/* eslint-disable no-param-reassign */
import produce from 'immer';

import { IS_CONNECTED } from '../actions/userActions';


const initialState = {
  isConnected : null,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case IS_CONNECTED: {
      const {isConnected} = action.payload;
      return produce(state, (draft) => {
        draft.isConnected = isConnected;
      });
    }

    default: {
      return state;
    }
  }
};

export default userReducer;
